import { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Checkbox, Input, ModalV2 } from '@utilities';

import { getDefaultNetName } from '../../utilities/helpers';

import styles from './_index.module.scss';

const RowNetEditor = ({ net, onCancel, onSave, options, questionLabel }) => {
  const [name, setName] = useState(net?.name ?? '');
  const [selectedOptionIds, setSelectedOptionIds] = useState(net?.optionIds ?? []);

  const canSave = selectedOptionIds.length >= 2;

  const handleToggle = (optionId) => {
    setSelectedOptionIds((prev) =>
      prev.includes(optionId) ? prev.filter((id) => id !== optionId) : [...prev, optionId]
    );
  };

  const handleSave = () => {
    const members = options.filter(({ id }) => selectedOptionIds.includes(id));
    onSave({
      name: name.trim() || getDefaultNetName(members),
      optionIds: selectedOptionIds,
    });
  };

  return (
    <ModalV2
      buttons={[
        <Button key="cancel" onClick={onCancel} text="Cancel" variant="secondary" />,
        <Button
          isDisabled={!canSave}
          key="save"
          onClick={handleSave}
          text={net ? 'Save row net' : 'Add row net'}
        />,
      ]}
      isActive
      onClose={onCancel}
      title={net ? 'Edit row net' : 'Add row net'}
    >
      <div className={styles['row-net-editor']}>
        <p className={styles['row-net-editor-question']}>{questionLabel}</p>
        <Input
          aria-label="Row net name"
          label="Net name"
          onChange={(value) => setName(String(value))}
          placeholder="Defaults to the selected options"
          value={name}
        />
        <ul className={styles['row-net-editor-options']}>
          {options.map(({ id, label }) => (
            <li key={id}>
              <Checkbox
                id={`row-net-option-${id}`}
                isChecked={selectedOptionIds.includes(id)}
                label={label}
                onChange={() => handleToggle(id)}
                title={label}
                value={id}
              />
            </li>
          ))}
        </ul>
        {!canSave && (
          <p className={styles['row-net-editor-hint']}>
            Select at least two answer options to create a net.
          </p>
        )}
      </div>
    </ModalV2>
  );
};

RowNetEditor.propTypes = {
  net: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    optionIds: PropTypes.arrayOf(PropTypes.string),
  }),
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  questionLabel: PropTypes.string.isRequired,
};

export default RowNetEditor;
